module.exports = __webpack_public_path__ + "static/media/marriage.12753a66.jpg";